<div
    class="agpr-left-sidebar"
    [ngClass]="{'agpr-collapseSidebar': collapseSidebar}"
>
    <!-- Collapse Button -->
    <agpr-button
        class="agpr-left-sidebar-collapseBtn"
        [icon]="leftSidebarCollapseBtnIcon"
        [style]="buttonTypes.icon"
        [tooltip]="collapseSidebar ? 'Core.expand' : 'Core.collapse'"
        (click)="collapseLeftSidebar();"
    ></agpr-button>

    <div class="agpr-left-sidebar-hover-borderLeft"></div>

    <h1 class="u-srOnly">{{ 'Discover.distributionReport.amplify.newsroom.heading' | localize }}</h1>

    <!-- Dropdown -->
    @if (sections.length > 0) {
        <nav class="agpr-left-sidebar-navbar">
            @if (!collapseSidebar) {
                <agpr-dropdown
                    [id]="'leftSidebar.dropdown'"
                    class="agpr-left-sidebar-navbar-dropdown"
                    [options]="sections"
                    optionLabel="label"
                    [(ngModel)]="selectedSectionValue"
                    (ngModelChange)="selectedSectionChanged()"
                    [inputTooltip]="selectedSectionValue.label"
                    [showTooltip]="true"
                ></agpr-dropdown>
            }
            <agpr-button
                [style]="buttonTypes.icon"
                [id]="'leftSidebar.amplifyButton'"
                class="agpr-left-sidebar-navbar-amplifyButton"
                icon="fa-regular fa-duotone fa-square-plus"
                [tooltip]="amplifyButtonLabel"
                (click)="showAmplify()"
            ></agpr-button>
        </nav>
    }

    <!-- List Items -->
    <div
        *ngIf="!collapseSidebar"
        class="agpr-left-sidebar-stories"
        [agprLoading]="storyLoading"
    >
        @if (!storyLoading) {
            <div class="agpr-left-sidebar-filter">
                <span class="agpr-left-sidebar-filterDropdown">
                    <agpr-filter-dropdown
                        [id]="'newsroom_leftSidebar_filters'"
                        class="agpr-left-sidebar-filterDropdown--filter"
                        [showQuickFilter]="true"
                        [quickFilterPlaceholder]="'Newsroom.filter.placeholder'"
                        [ariaDescribedBy]="'newsroom_leftSidebarChips'"
                    ></agpr-filter-dropdown>
                    <agpr-sort-order
                        id="newsroom_leftSidebar_sortOrder"
                        tooltip="Discover.targeting.tooltips.sort"
                        optionKey="enumValue"
                        optionLabel="displayString"
                    ></agpr-sort-order>
                </span>
                <agpr-filter-chips
                    class="agpr-left-sidebar-filterChips"
                    [id]="'newsroom_leftSidebarChips'"
                    [noContainerWhenEmpty]="true"
                ></agpr-filter-chips>
            </div>

            <agpr-scroll-panel (scrolledToBottom)="scrolledToBottom()">
                <div *ngIf="totalStories != null && totalStories != 0">
                    <ul
                        #storyList
                        class="agpr-left-sidebar-storyList"
                    >
                        <li
                            *ngFor="let story of sidebarModel.items; index as i"
                            class="agpr-left-sidebar-storyListItem"
                            [ngClass]="{'agpr-left-sidebar-activeStory': selectedItem.id == story.id}"
                            pTooltip="{{ story.name }}"
                            (mouseenter)="hideKebabMenu(event)"
                        >
                            <span
                                class="agpr-left-sidebar-storyListItem--activeBar"
                                [ngClass]="{'agpr-left-sidebar-storyListItem--activeBar-show': selectedItem.id == story.id}"
                            ></span>
                            <span class="agpr-left-sidebar-storyListLink">
                                <a
                                    id="newsroom_leftSidebar_item_{{ i }}"
                                    class="agpr-left-sidebar-storyNameList"
                                    tabindex="0"
                                    (keydown)="loadPreviewPanel(story)"
                                    (click)="loadPreviewPanel(story)"
                                >

                                    {{ story.name }}
                                </a>
                                <span class="agpr-left-sidebar-storyListSpan">
                                    {{ story.status }}
                                </span>
                                <agpr-kebab-menu
                                    #kebabMenu
                                    *ngIf="!!story.options&&story.options.length > 0"
                                    class="agpr-left-sidebar-option"
                                    [options]="story.options"
                                    [data]="story"
                                    panelPositionX="right"
                                ></agpr-kebab-menu>
                            </span>

                        </li>
                    </ul>
                </div>
                @if (totalStories === null || totalStories === 0 || sidebarModel.items?.length === 0) {
                    <div class="agpr-left-sidebar-noStoryContainer">
                        <agpr-message
                            class="agpr-left-sidebar-noStory"
                            [severity]="messageSeverityEnum.noContent"
                        >
                            {{ noItemsText }}
                        </agpr-message>
                    </div>
                }
            </agpr-scroll-panel>
        }
    </div>
</div>
